import { Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface ExternalSupplierDetailProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string | JSX.Element;
  detail?: string | JSX.Element | null;
  editMode?: boolean;
}

export const ExternalSupplierDetail = ({ label, detail, editMode = false, className, ...props }: ExternalSupplierDetailProps) => (
  <div className={clsx("col-span-1 flex flex-col gap-2", className)} {...props}>
    {typeof label === "string" ? (
      <Typography variant="paragraph" className={clsx({ "text-neutral-dark-gray": !editMode })}>
        {label}
      </Typography>
    ) : (
      label
    )}
    {!detail ? (
      <Typography variant="action">-</Typography>
    ) : typeof detail === "string" ? (
      <Typography variant="action" className="break-words">
        {detail}
      </Typography>
    ) : (
      detail
    )}
  </div>
);
